export class MessageEntity {
  id: string = '';
  sender: string = ''; // Utilisateur correctement typé
  content: string = '';
  timestamp: string = '';
  conversation: string = ''; // Conversation correctement typée
}
